import React, {useEffect, useState} from "react";
import {useBroadcastPermissions} from "./hooks";
import {Announcement, Campaign} from "@mui/icons-material";
import AddBroadcastForm from "./AddBroadcastForm";


export default function FloatingAddBroadcast(props) {
    const [isOpen, setIsOpen] = useState(false);
    const broadcastPermissions = useBroadcastPermissions()

    if (!broadcastPermissions.canAdd) {
        return null;
    }

    if (isOpen) {
        return (
            <div className="position-fixed bottom-0 left-0 mb-2 z-3">
                <div className="mb-2 d-flex justify-content-between align-items-center rounded bg-white border border-1 shadow">
                    <AddBroadcastForm toggle={() => {
                        setIsOpen(false)
                    }}/>
                </div>
                <button
                    className="btn btn-secondary"
                    style={{ width: '100%' }}
                    onClick={() => setIsOpen(false)}
                >
                    Cancel
                </button>
            </div>
        )
    }
    // return null;

    return (
        <div className="position-fixed bottom-0 left-0 mb-2 z-3 opacity-50">
            <button
                className="btn btn-primary"
                style={{ width: '100%' }}
                onClick={() => {
                    setIsOpen(true);
                }}
            >
                <Campaign className="me-2"/>
                Add Broadcast
            </button>
        </div>
    )
}